import BaseAPI from "../api";

const path: string = "/advisor-file";

export type listType = {
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
};

export class advisorFileApi extends BaseAPI {
  static getAllAdvisorFile(query?: listType): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static getAdvisorFileById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static createAdvisorFile(body: FormData): Promise<any> {
    return this.api.post(`${path}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static updateAdvisorFile(id: number, body: FormData): Promise<any> {
    return this.api.patch(`${path}/${id}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static deleteAdvisorFile(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static downloadFile(id: number): Promise<any> {
    return this.api.get(`${path}/${id}/download?type=any`, {
      responseType: "arraybuffer",
    });
  }
}
